import type { VueMessageType } from "vue-i18n";
import type { LocaleMessage } from '@intlify/core-base';

export enum LangCodes {
    EN = "en",
    FR = "fr",
    SYSTEM = "system"
}
export enum LangApiCodes {
    EN = "eng",
    FR = "fra",
}
export interface ISettingsLocales {
    code: LangCodes;
    translatedName: string;
}

export interface IMessage {
    [x: string]: LocaleMessage<VueMessageType>;
}

export interface ILocale {
    code: string;
    iso: string;
}

export enum AvailabilityLanguages {
    EN = "EN",
    FR = "FR",
    ALL = "ALL",
    NONE = "NONE",
}
